import Action from '../../Action'
// import './styles/ModalDeleteUSer.css'
import { useEffect, useState } from 'react';
import LoadSimple from '../../LoadSimple';
import { capitalizeFirstLetter } from '../../../utils/utils';
import './styles/ModalAddHost.css'
import { lang } from '../../generales/traduction';
import Search from '../../generales/Search';
import Paginador from '../../generales/Paginador';
const ModalAddHostUpdate = ({ languaje, appSelected, server, mode, setPoolRows, poolRows, handleShowPopup, closeAddHostModal }) => {
  const [hosts, setHosts] = useState({
    data: [],
    loading: true,
    error: null,
  })
  const [responseAction, setResponseAction] = useState({
    data: [],
    loading: false,
    error: null,
  })
  const [loading, setLoading] = useState(false)
  // console.log()
  useEffect(() => {
    buscar_cis();
  }, []);
  const buscar_cis = () => {
    setHosts({
      data: hosts.data,
      loading: true,
      error: hosts.error,
    });
    const fetchDataPost = async () => {
      try {
        const response = await fetch(
          server.url +
          "/api/v1/cassia/hostsBySoftwareKey/" + appSelected.softwarekey,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              accept: "application/json",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );
        if (response.ok) {
          const data1 = await response.json();

          setHosts({
            data: data1.data,
            loading: false,
            error: hosts.error,
          });
          // setLoading(false)
          // setCreateCisModalOpen(true)
        } else {
          const data1 = await response.json();
          throw new Error("Error en la solicitud");
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchDataPost();
  };

  const registrar = () => {
    setResponseAction({
      data: responseAction.data,
      loading: true,
      error: responseAction.error,
    });

    const data = {
      hostids: hostSelected.map(item => item.hostid),
      softwarekey: appSelected.softwarekey
    }
    const fetchDataPost = async () => {
      try {
        const response = await fetch(
          server.url +
          "/api/v1/cassia/update_software_several_hosts/",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              accept: "application/json",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
            body: JSON.stringify(data)
          }
        );
        if (response.ok) {
          const data1 = await response.json();

          setResponseAction({
            data: data1,
            loading: false,
            error: responseAction.error,
          });
          handleShowPopup('Completado!!!', '', data1.message, true)
          closeAddHostModal()
          // setLoading(false)
          // setCreateCisModalOpen(true)
        } else {
          const data1 = await response.json();
          setResponseAction({
            data: responseAction.data,
            loading: false,
            error: responseAction.error,
          });
          handleShowPopup('Error!!!', capitalizeFirstLetter(lang[languaje]['errorActionComplet']), data1.detail, false)
          throw new Error("Error en la solicitud");
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchDataPost();
  };
  const [allSelected, setAllSelected] = useState(false);
  const [hostSelected, setHostSelected] = useState([])
  // const [hostSelected,setHostSelected]=useState(hosts.filter(item => poolRows.includes(item.hostid)))
  const [contRowsSelected, setContRowSelected] = useState(0)
  const [searchResults, setSearchResults] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [limitList, setLimitList] = useState(50);
  const [pageActual, setPageActual] = useState(1);
  const [searchResult, setSearchResult] = useState(null);
  var dataList = searchTerm === "" ? hosts.data : searchResults;
  const startLimit = limitList * pageActual - limitList;
  const pages = parseInt(dataList.length / limitList) + 1;
  const handleSelectAll = () => {
    if (allSelected) {
      // Si ya está todo seleccionado, deselecciona todo
      setPoolRows([]);
      setHostSelected([]);
    } else {
      // Solo seleccionar los que no estan deshabilitados
      const validItems = dataList.filter(item => item.softwarestatus == null);
      setPoolRows(validItems.map(item => item.hostid));
      setHostSelected(validItems);
    }
    setAllSelected(!allSelected); // Alterna el estado de seleccionar todo
  };
  const handleSearch = (query) => {
    setSearchResult(`Resultados para: ${query}`);
  };
  const handleSelectChange = (e) => {
    setPageActual(1)
    setLimitList(e.target.value); setPageActual(1);
  };
  const rowSelected = (elemento) => {
    if (allSelected) {
      setAllSelected(false)
    }

    setPoolRows((prevRows) => {
      // Busca si el hostid ya existe en el array
      const exists = prevRows.includes(elemento.hostid);
      // Si existe, filtra para eliminarlo, si no existe, lo agrega
      if (exists) {
        return prevRows.filter(hostid => hostid !== elemento.hostid);
      } else {
        return [...prevRows, elemento.hostid];
      }
    });
    setHostSelected((prevRows) => {
      // Busca si el hostid ya existe en el array de objetos
      const exists = prevRows.some(item => item.hostid === elemento.hostid);

      // Si existe, filtra para eliminar el objeto, si no existe, lo agrega
      if (exists) {
        return prevRows.filter(item => item.hostid !== elemento.hostid);
      } else {
        return [...prevRows, elemento];
      }
    });
  };
  return (
    <>
      <div className="modal-GS-content">
        <div className='card-modal-gs modal-verificate'>
          <div className='head-card-modal-gs'>
            <div className='title-head-card-modal-gs'>
              {lang[languaje]['agregar'].toUpperCase() + " " + lang[languaje]['dispositivos'].toUpperCase()}
            </div>
          </div>
          <div className='content-card-modal-gs' style={{ overflowY: 'scroll', scrollbarWidth: 'thin' }}>
            <div className='half-content-card-modal-gs'>
              <>
                <div className='head-cis'>
                  <div className='title-cis'>
                    <Search
                      searchResults={searchResults}
                      setSearchResults={setSearchResults}
                      searchTerm={searchTerm}
                      setSearchTerm={setSearchTerm}
                      onSearch={handleSearch}
                      dataObject={hosts.data}
                      searchResult={searchResult}
                      setSearchResult={setSearchResult}
                      languaje={languaje}
                    />
                    <div className={"cont-result-registers" + mode} style={{ width: '25%', bottom: '0px' }}>

                      {/* <p style={{  textAlign: "center" ,fontSize:'var(--font-size-xSmall)'}}>
                  &nbsp;
                  {capitalizeFirstLetter(lang[languaje]['resultadosEncontrados'])+" (" +
                    dataList.length +
                    ") " 
                    }
                </p>  */}
                    </div>



                  </div>

                </div>
                <div className='cont-cis'>
                  <>
                    <div className="main-panel-cis">
                      <div className="compact-content-portafolio">
                        <div className={"content-portafolio-head" + mode}>
                          {
                            // (contRowsSelected!=0)?

                            // :''
                          }
                        </div>
                        <div className="content-portafolio">
                          <div className="cont-portafolio-table">
                            <div className="content-card-portafolio" id="content">

                              <div className="cont-table-portafolio">
                                <div className={"head-table-portafolio" + mode}>
                                  <div className="compact-head-table-portafolio">
                                    <div className="field-head-table-mantenimiento field-medium">  <div className='cont-checkbox'>
                                      <input type='checkbox' className='NotifiCheckBox ' checked={allSelected} style={{ height: '15px' }} onClick={() => handleSelectAll()} ></input>
                                    </div></div>
                                    {/* <div className="field-head-table-mantenimiento field-small"> ID</div> */}
                                    <div className="field-head-table-mantenimiento field-larger" style={{ width: '80%' }} >{capitalizeFirstLetter(lang[languaje]['nombre'])} </div>
                                    <div className="field-head-table-mantenimiento field-medium" style={{ width: '15%' }}>{'IP'}</div>

                                  </div>
                                </div>
                                <div className="body-table-portafolio">
                                  {(hosts.loading) ? <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%' }}><LoadSimple /></div> :
                                    <>
                                      <div className="cont-row-user-list">
                                        {(
                                          // dataList
                                          //   .slice(startLimit, parseInt(pageActual) * parseInt(limitList))
                                          (dataList
                                            .slice(startLimit, parseInt(pageActual) * parseInt(limitList)).map((elemento, indice) => (
                                              <div
                                                className={"row-table-portafolio" + mode}
                                                key={indice}
                                                style={{ background: ((elemento.softwarestatus != null) ? 'var(--border-table-color)' : '') }}
                                              >
                                                <div className="field-body-table-mantenimiento field-medium">
                                                  <div className='cont-checkbox'>
                                                    <input type='checkbox' checked={poolRows.some((row) => row === elemento.hostid)} className='NotifiCheckBox ' style={{ height: '15px' }} onChange={() => rowSelected(elemento)} disabled={elemento.softwarestatus != null}></input>
                                                  </div>
                                                </div>

                                                <div className="field-body-table-mantenimiento field-larger" style={{ width: '80%' }}>
                                                  {elemento.host}
                                                </div>
                                                <div className="field-body-table-mantenimiento field-medium" style={{ width: '15%' }}>
                                                  {elemento.ip}
                                                </div>

                                              </div>
                                            )))

                                        )}
                                        {(dataList.length == 0) ? (
                                          <div className="no-results">{capitalizeFirstLetter(lang[languaje]['sinResultados'])}.</div>
                                        ) : (
                                          ""
                                        )}
                                      </div>

                                    </>
                                  }
                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                        <div className={"content-portafolio-footer" + mode}>
                          <div className="cont-display-paginador" style={{ position: 'absolute', left: '0%', justifyContent: 'start' }}>

                            {/* <div className={"cont-half-display-paginador"+mode}>
          <p style={{  textAlign: "center" }}>
                          &nbsp;
                          {(contRowsSelected!=0)?"("+contRowsSelected+")  registros seleccionados":''}
                    </p> 
                
          </div> */}
                          </div>
                          <div className="cont-display-paginador" style={{ width: '60%' }}>
                            <Paginador pages={pages}
                              pageActual={pageActual}
                              setPageActual={setPageActual}
                              mode={mode}></Paginador>
                          </div>
                          <div className="cont-display-paginador" style={{ width: '50%' }}>
                            <div className={"cont-half-display-paginador" + mode}>

                              <div>
                                <label htmlFor="selector">{capitalizeFirstLetter(lang[languaje]['filasPagina'])}: </label>
                                <select id="selector" value={limitList} className="pageSelector" onChange={handleSelectChange}>
                                  <option value={10}>10</option>
                                  <option value={50} >50</option>
                                  <option value={100}>100</option>
                                  <option value={500}>500</option>
                                  <option value={1000}>1000</option>
                                </select>


                              </div>
                            </div>
                            <div className={"cont-half-display-paginador" + mode} >
                              <p style={{ textAlign: "center", fontSize: 'var(--font-size-xSmall) !important' }}>
                                &nbsp;
                                {"(" +
                                  (startLimit + 1) +
                                  " - " +
                                  (dataList.length > parseInt(pageActual) * parseInt(limitList)
                                    ? parseInt(pageActual) * parseInt(limitList)
                                    : dataList.length) +
                                  ")  " + lang[languaje]['de'] + " " +
                                  dataList.length +
                                  " " + lang[languaje]['resultados']}
                              </p>

                            </div>
                          </div>

                        </div>
                      </div>
                    </div>

                  </>

                </div>
              </>

            </div>
            <div className='half-content-card-modal-gs'>
              <>
                <div className='head-cis'>
                  <div className="cont-buttons-panel" style={{ width: '50%', display: 'flex' }}>
                    {
                      (responseAction.loading) ? <LoadSimple></LoadSimple> :

                        <>
                          <Action
                            disabled={(hostSelected.length == 0)}
                            origen="Azul"
                            titulo={"" + capitalizeFirstLetter(lang[languaje]['actualizar'])}
                            action={registrar}
                          />

                        </>

                    }

                    <Action
                      disabled={false}
                      origen="Cancelar"
                      titulo={"" + capitalizeFirstLetter(lang[languaje]['cancelar'])}
                      action={closeAddHostModal}
                    />

                  </div>

                </div>
                <div className='cont-cis'>
                  <>
                    <div className="main-panel-cis">
                      <div className="compact-content-portafolio">
                        <div className={"content-portafolio-head" + mode} style={{ background: 'var(--third-color)', color: 'var(--white-color)' }}>
                          <div className='title-host-added'>{capitalizeFirstLetter(lang[languaje]['hostSelected'])}</div>
                        </div>
                        <div className="content-portafolio">
                          <div className="cont-portafolio-table">
                            <div className="content-card-portafolio" id="content">

                              <div className="cont-table-portafolio">

                                <div className="body-table-portafolio">

                                  <>
                                    <div className="cont-row-user-list">

                                      {(
                                        hostSelected
                                          .map((elemento, indice) => (
                                            <div className='content-row-host-selected' key={indice}>
                                              <div className='row-host-selected'>
                                                <div className='text-host-selected'>
                                                  {elemento.host}
                                                </div>
                                                <div className='delete-host-selected' onClick={(() => rowSelected(elemento))}>
                                                  X
                                                </div>
                                              </div>
                                            </div>
                                          ))
                                      )}
                                      {(hostSelected.length == 0) ? (
                                        <div className="no-results">{capitalizeFirstLetter(lang[languaje]['sinResultados'])}.</div>
                                      ) : (
                                        ""
                                      )}
                                    </div>

                                  </>

                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                        <div className={"content-portafolio-footer" + mode} style={{ justifyContent: 'center' }}>
                          <div className="cont-display-paginador" style={{ position: 'absolute', justifyContent: 'center', width: '50%' }}>

                            <div className={"cont-half-display-paginador" + mode}>
                              <p style={{ textAlign: "center" }}>
                                &nbsp;
                                {"(" + hostSelected.length + ")  registros seleccionados"}
                              </p>

                            </div>
                          </div>



                        </div>
                      </div>
                    </div>

                  </>

                </div>
              </>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ModalAddHostUpdate